import React, { useEffect } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { MomentControl } from '../components/wall/MomentControl';
import { DeskTopBar } from '../components/desk/DeskTopBar';
import { ConversationPanel } from '../components/desk/ConversationPanel';
import { DeskStageArea } from '../components/desk/DeskStageArea';
import { AgentsAtWork } from '../components/desk/AgentsAtWork';
import { WaitingStack } from '../components/desk/WaitingStack';
import { useDeskStage } from '../components/desk/useDeskStage';
import { Toast } from '../components/ui/Toast';
import { NoodstopSheet } from '../components/ui/NoodstopSheet';

/** Commandocentrum on the desk monitor (2560×1440 and 1920×1080): a living operations room, calm enough to keep open all day. */
export function CommandCenter() {
  const stage = useDeskStage();
  useEffect(() => {
    if (!stage.toast) return;
    const id = window.setTimeout(stage.dismissToast, 3500);
    return () => window.clearTimeout(id);
  }, [stage.toast, stage.dismissToast]);
  return <div className="relative flex min-h-screen w-full flex-col overflow-hidden bg-night-950 text-ink xl:h-screen" data-id="element-1681" data-mp="2zl69sjnwooyh">
      {/* Soft glow behind Anna — neutral during work */}
      <div aria-hidden className="pointer-events-none absolute left-[-10%] top-[5%] h-[70vh] w-[50vw] rounded-full opacity-60" style={{
      background: 'radial-gradient(closest-side, rgb(var(--accent) / 0.08), transparent)'
    }} data-id="element-1682" data-mp="38j9w3i6ptprc" />

      <MomentControl index={stage.momentIndex} count={stage.momentCount} title={stage.moment.title} onPrev={stage.prev} onNext={stage.next} data-id="element-1683" data-mp="3mjsz2awbq5mn" />
      <DeskTopBar stage={stage} data-id="element-1684" data-mp="3rbu9rsdufoak" />

      <main className="relative z-10 grid min-h-0 flex-1 grid-cols-1 gap-6 px-6 py-5 lg:grid-cols-[minmax(320px,30%)_1fr] xl:grid-cols-[minmax(340px,27%)_minmax(0,1fr)_minmax(360px,25%)] 2xl:gap-8" data-id="element-1685" data-mp="3rcm4z23j3k0b">
        <ConversationPanel stage={stage} data-id="element-1686" data-mp="5189g2wlaah4" />
        <DeskStageArea stage={stage} data-id="element-1687" data-mp="a1mh3jua3iem" />
        <aside className="flex min-h-0 flex-col gap-4 lg:col-span-2 xl:col-span-1" data-id="element-1688" data-mp="a2nsxqj4c8xe">
          <div className="flex min-h-0 flex-[3] flex-col" data-id="element-1689" data-mp="3gkftn45dpjme">
            <AgentsAtWork stage={stage} data-id="element-1690" data-mp="3bktg0tln21d2" />
          </div>
          <div className="flex min-h-0 flex-[2] flex-col" data-id="element-1691" data-mp="3bmedaqzc7yem">
            <WaitingStack stage={stage} data-id="element-1692" data-mp="3q9prz1qtfyiy" />
          </div>
        </aside>
      </main>

      <div className="pointer-events-none fixed inset-x-0 bottom-8 z-50 flex justify-center px-4" data-id="element-1693" data-mp="3li7lxz9xr7r4">
        <AnimatePresence data-id="element-1694" data-mp="348ge3ewckmm">
          {stage.toast && <motion.div key={stage.toast.id} className="pointer-events-auto" initial={{
          opacity: 0,
          y: 12,
          scale: 0.98
        }} animate={{
          opacity: 1,
          y: 0,
          scale: 1
        }} exit={{
          opacity: 0,
          y: 8
        }} transition={{
          duration: 0.2,
          ease: [0.23, 1, 0.32, 1]
        }} data-id="element-1695" data-mp="36upi7hfr86y">
              <Toast tone={stage.toast.tone} title={stage.toast.text} onClose={stage.dismissToast} data-id="element-1696" data-mp="2etiwofdmkutv" />
            </motion.div>}
        </AnimatePresence>
      </div>

      <NoodstopSheet open={stage.stopped} onResume={stage.resume} data-id="element-1697" data-mp="pd6ug1upf5gp" />
    </div>;
}